module.exports = "../images/pano-background-wall-2.jpg";